$("a[href^='http://']").attr("target","_blank").addClass('is-external');
$("a[href^='https://']").attr("target","_blank").addClass('is-external');
